import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Polish PESEL validator following Single Responsibility Principle
 */
export class PeselValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Polish PESEL',
      pattern: /^\d{11}$/,
      length: 11
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'PESEL must be exactly 11 digits'
    );
  }

  validateChecksum(id) {
    const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
    let sum = 0;

    for (let i = 0; i < 10; i++) {
      sum += parseInt(id[i]) * weights[i];
    }

    const expectedChecksum = (10 - (sum % 10)) % 10;
    const actualChecksum = parseInt(id[10]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid PESEL checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid PESEL');
  }
}